import React from "react";
import { Icon } from "@iconify/react";

const SettingsIcon = () => (
  <Icon icon="lucide:settings" width={18} height={18} />
);

export default SettingsIcon;
